import React from "react";
import { AlertStock } from "src/services/Api/Organization/types";
import { DashboardProductsListBody } from "./DashboardProductsListBody";
import { DashboardProductsListHeader } from "./DashboardProductsListHeader";

interface DashboardProductsListProps {
	stock: AlertStock;
}

export const DashboardProductsList = ({ stock }: DashboardProductsListProps) => {
	return (
		<div className="pt-2">
			<DashboardProductsListHeader
				stock_id={stock.stock_id}
				stock_name={stock.stock_name}
				below_zero_count={stock.below_zero_count}
			/>
			<DashboardProductsListBody stock={stock} />
		</div>
	);
};
